import { RubricBankItem } from 'libs/end-to-end/src/types/rubric-bank/rubric-bank-item';
import { RubricBankItemForWrite } from 'libs/end-to-end/src/types/rubric-bank/rubric-bank-item';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { useSimpleWritePattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleWritePattern';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { WritePatternHook } from 'apps/sigma2-ui/src/lib/hooks/useWritePattern';
import { RubricBankConstruct } from 'libs/end-to-end/src/types/rubric-bank/rubric-bank-construct';
import { RubricBankConstructForWrite } from 'libs/end-to-end/src/types/rubric-bank/rubric-bank-construct';

export type UseRubricConstructsDataPayload = {
  constructs: RubricBankConstruct[];
  organizationId: string;
  databaseId: string;
  readPattern: ReadPatternHook<RubricBankConstruct[]>;
  createConstructPattern: WritePatternHook<
    EmptyObject,
    RubricBankConstructForWrite
  >;
  singleSelectConfig: {
    currentConstructId: string | null;
    setCurrentConstructId: (constructId: string | null) => void;
  } | null;
};

export const useRubricConstructsData = ({
  organizationId,
  databaseId,
  isSelectEnabled,
}: {
  organizationId: string;
  databaseId: string;
  isSelectEnabled: boolean;
}): UseRubricConstructsDataPayload => {
  const [currentConstructId, setCurrentConstructId] = useState<string | null>(
    null,
  );

  const getUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/rubric-bank-constructs`;
  }, [organizationId, databaseId]);

  const readConstructsPattern = useSimpleReadPattern({
    getUrlFn,
    canRead: true,
    responseSchema: RubricBankConstruct.array(),
  });

  const createConstructPattern = useSimpleWritePattern({
    getUrlFn,
    method: 'POST',
    canWrite: true,
    writeSchema: RubricBankConstructForWrite,
    responseSchema: EmptyObject,
  });

  const constructs = useMemo(() => {
    return readConstructsPattern.status === 'done'
      ? readConstructsPattern.entity
      : [];
  }, [readConstructsPattern]);

  return useMemo(() => {
    return {
      constructs,
      organizationId,
      databaseId,
      readPattern: readConstructsPattern,
      createConstructPattern,
      singleSelectConfig: isSelectEnabled
        ? { currentConstructId, setCurrentConstructId }
        : null,
    };
  }, [
    constructs,
    organizationId,
    databaseId,
    currentConstructId,
    isSelectEnabled,
    readConstructsPattern,
    createConstructPattern,
    setCurrentConstructId,
  ]);
};
